import { BUSINESS_BOOKING_API_URL, API_BASE_URL } from '../globals';
import {
  GET_PRICING_CONTRACTS,
  CREATE_PRICING_CONTRACTS,
  DELETE_PRICING_CONTRACTS,
  BULK_UPLOAD_PRICING_CONTRACTS,
  DOWNLOAD_SAMPLE_CONTRACT,
  BULK_UPLOAD_MASTER_CONTRACTS,
  // New routes for pricing master contracts
  GET_CHARGES_METADATA,
  GET_PRICING_DATA,
  UPLOAD_PRICING_DATA,
  DELETE_PRICING_RATE,
  BULK_DELETE_PRICING_DATA,
  DOWNLOAD_PRICING_DUMP_V2,
  GET_CHARGE_SAMPLE_CSV,
  UPDATE_PRICING_RATE,
  DOWNLOAD_PRICING_DUMP_SYNC,
} from './routes';
import { GET, POST } from './apiHandler';

export const getContracts = async (params) => {
  return GET(`${BUSINESS_BOOKING_API_URL}${GET_PRICING_CONTRACTS}`, params);
};

export const createOrEditContract = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${CREATE_PRICING_CONTRACTS}`, body);
};

export const bulkUploadContract = async (body) => {
  return POST(
    `${BUSINESS_BOOKING_API_URL}${BULK_UPLOAD_PRICING_CONTRACTS}`,
    body,
  );
};

export const deleteContract = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${DELETE_PRICING_CONTRACTS}`, body);
};

export const downloadContract = async () => {
  return GET(`${API_BASE_URL}${DOWNLOAD_SAMPLE_CONTRACT}`);
};

export const bulkUploadMasterContracts = async (body) => {
  return POST(
    `${BUSINESS_BOOKING_API_URL}${BULK_UPLOAD_MASTER_CONTRACTS}`,
    body,
  );
};

// Pricing Master Contracts API functions
export const getChargesMetadata = async (params = {}) => {
  return GET(`${BUSINESS_BOOKING_API_URL}${GET_CHARGES_METADATA}`, params);
};

export const getPricingData = async (params) => {
  return GET(`${BUSINESS_BOOKING_API_URL}${GET_PRICING_DATA}`, params);
};

export const uploadPricingData = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${UPLOAD_PRICING_DATA}`, body);
};

export const bulkDeletePricingData = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${BULK_DELETE_PRICING_DATA}`, body);
};

export const downloadPricingDumpV2 = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${DOWNLOAD_PRICING_DUMP_V2}`, body);
};

export const downloadPricingDumpSync = async (params) => {
  return GET(`${BUSINESS_BOOKING_API_URL}${DOWNLOAD_PRICING_DUMP_SYNC}`, params, 'blob');
};

export const getChargeSampleCSV = async (params) => {
  return GET(`${BUSINESS_BOOKING_API_URL}${GET_CHARGE_SAMPLE_CSV}`, params, 'blob');
};

export const updatePricingRate = async (body) => {
  return POST(`${BUSINESS_BOOKING_API_URL}${UPDATE_PRICING_RATE}`, body);
};

export const deleteIndexedRate = async (body) => {
    return POST(`${BUSINESS_BOOKING_API_URL}${DELETE_PRICING_RATE}`, body);
};
